import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { allTechnicians } from 'app/mocks/data/users/technicians'

import { api } from 'app/utils/constants'

export const deleteTechnician = http.delete(
    `${process.env.REACT_APP_API_ADDRESS}/${api.users.technicians.DETAILS}`,
    ({ params }) => {
        const { id } = params

        const technicianFound = allTechnicians.find(
            (technician) => technician.id.toString() === id,
        )
        // Not found
        if (!technicianFound) {
            return HttpResponse.json(undefined, {
                status: StatusCodes.NOT_FOUND,
            })
        }

        return HttpResponse.json(undefined, {
            status: StatusCodes.NO_CONTENT,
        })
    },
)
